import { log } from './log';
import { pixelsInject } from './inject-pixels';
import { pixelsOutstream } from './outstream-pixels';
import { withinDeliveryCap } from './inject-common';

const renderHorizontalMidArticlePlaylistPlayer = async (
  midElementId: string,
  options: PixelDualAppConfig,
  where: 'hero' | 'mid'
): Promise<boolean> => {
  if (options.mockedMidArticleSection && where === 'mid') {
    pixelsOutstream(midElementId).setOverrideKey(options.mockedMidArticleSection);
  } else if (options.mockedSection && where === 'hero') {
    pixelsOutstream(midElementId).setOverrideKey(options.mockedSection);
  }
  pixelsOutstream(midElementId).setPubId(options.organisation);
  if (options.disablePlaylist) {
    pixelsOutstream(midElementId).disablePlaylist();
  }
  if (typeof options.midArticlePlaylist === 'string') {
    pixelsOutstream(midElementId).setPlaylist(options.playlist);
  } else if (Array.isArray(options.midArticlePlaylist)) {
    pixelsOutstream(midElementId).setPlaylist(
      // get random playlist
      options.midArticlePlaylist[Math.floor(Math.random() * options.midArticlePlaylist.length)]
    );
  } else {
    throw Error("Wrong type for mid article section. It's either string or string list");
  }
  pixelsOutstream(midElementId).setBidConfig(options.bidConfig);
  pixelsOutstream(midElementId).setAdTag(options.adTagUrl);
  return pixelsOutstream(midElementId).setup(options, options.contextualDeliveryCap);
};

const renderVideoInMidArticle = async (
  elementId: string,
  options: PixelDualAppConfig,
  where: 'hero' | 'mid'
): Promise<boolean> => {
  // if (getViewportWidth() <= 480) {
  //   const publisherId = options.organisation;
  //   const playlistId = options.playlist;
  //   const pixelsPageId = options.pageId;
  //   const playlistVideo = await getVerticalPlaylist(pixelsPageId, publisherId, playlistId);
  //   if (playlistVideo.length && hasContextualVideo(playlistVideo)) {
  //     log('pixels', 'has vertical playlist with contextual video...', playlistVideo);
  //     // render mobile-only vertical player...
  //     shortsLoader(elementId, publisherId, playlistId, playlistVideo);
  //     return true;
  //   }
  // }

  return renderHorizontalMidArticlePlaylistPlayer(elementId, options, where);
};

export default (config: PixelDualConfig) => {
  const { adTagUrlPromise, ...restOfConfig } = config;

  return (heroElementId: string, midElementId: string) => ({
    setup: async (options: PixelsDualSetupParam, callback: (doNotCont: boolean) => void) => {
      const adTagUrl = await adTagUrlPromise;

      const applicationConfig = {
        ...restOfConfig,
        ...options,
        adTagUrl,
      };

      let pixelsInPlay;

      if (applicationConfig.contextualDeliveryCap > 0 && !applicationConfig.useOutstreamForHero) {
        log('pixels', `setup called with hero: '${heroElementId}' and mid: '${midElementId}'`);
        pixelsInject(heroElementId).setBidConfig(applicationConfig.bidConfig);
        pixelsInject(heroElementId).setPubId(applicationConfig.organisation);
        pixelsInject(heroElementId).setPlaylist(applicationConfig.playlist);
        if (applicationConfig.disablePlaylist) {
          pixelsInject(midElementId).disablePlaylist();
        }

        log('pixels', 'ad tag', adTagUrl);
        pixelsInject(heroElementId).setAdTag(adTagUrl);

        pixelsInPlay = await pixelsInject(heroElementId).setup(options, applicationConfig.contextualDeliveryCap);
      } else if (
        applicationConfig.contextualDeliveryCap > 0 &&
        withinDeliveryCap(applicationConfig.contextualDeliveryCap) &&
        applicationConfig.useOutstreamForHero
      ) {
        pixelsInPlay = await renderVideoInMidArticle(heroElementId, applicationConfig, 'hero');
      }

      if (
        !pixelsInPlay &&
        applicationConfig.playlistDeliveryCap > 0 &&
        withinDeliveryCap(applicationConfig.playlistDeliveryCap)
      ) {
        pixelsInPlay = await renderVideoInMidArticle(midElementId, applicationConfig, 'mid');
      }

      // trigger callback from the host
      callback && callback(pixelsInPlay);
    },
  });
};
